const state = {
   hasInsurance: false,
};

const mutations = {
   setHasInsurance(state, data) {
      state.hasInsurance = data;
   },
};

const actions = {
   setHasInsurance: function (commit, data) {
      commit("setHasInsurance", data);
   },
};

const getters = {};

export const insurance = {
   namespaced: true,
   state,
   mutations,
   actions,
   getters,
};
